/**
 * Merges class names ensuring the custom class has highest specificity
 * by repeating it 4 times to boost its specificity in CSS calculations
 *
 * @param {string} baseClass - Base component class like 'header'
 * @param {string} customClass - Custom class that should override the base
 * @returns {string} - Combined class string with specificity boosting
 */
export function mergeClasses(baseClass, customClass) {
  // Handle falsy values
  if (!customClass) return baseClass || ''
  if (!baseClass) return customClass

  // Create specificity booster by repeating the custom class 4 times
  // Browsers deduplicate classes for rendering but count each occurrence for specificity
  const specificityBoost = Array(4).fill(customClass).join(' ')

  // Return the combined classes with the specificity booster
  return `${baseClass} ${customClass} ${specificityBoost}`
}

const hasOwn = {}.hasOwnProperty

export default function classNames() {
  let classes = ''

  for (let i = 0; i < arguments.length; i++) {
    const arg = arguments[i]
    if (arg) {
      classes = appendClass(classes, parseValue(arg))
    }
  }

  return classes
}

function parseValue(arg) {
  if (typeof arg === 'string') {
    return arg
  }

  if (typeof arg !== 'object') {
    return ''
  }

  if (Array.isArray(arg)) {
    return classNames.apply(null, arg)
  }

  if (
    arg.toString !== Object.prototype.toString &&
    !arg.toString.toString().includes('[native code]')
  ) {
    return arg.toString()
  }

  let classes = ''

  for (const key in arg) {
    if (hasOwn.call(arg, key) && arg[key]) {
      classes = appendClass(classes, key)
    }
  }

  return classes
}

function appendClass(value, newClass) {
  if (!newClass) {
    return value
  }

  return value ? value + ' ' + newClass : newClass
}
